import { gql } from '@apollo/client';

const BOOKING_SEARCH = gql`
  query BOOKING_SEARCH($slug: String) {
    booking: boatnew_booking(where: { id: { _eq: $slug } }) {
      id
      confirmed
      status
      source
      pickupLocation: pickup_location
      pickupTime: pickup_time
      tourDate: tour_date
      tourTime: tour_time
      notes: notes_customer
      customer_notes
      promo_code_id
      total_price
      pickup_coordinates
      customer {
        id
        name: contact_name
        email
        secondaryEmail: secondary_email
        phone
        secondaryPhone: secondary_phone
      }
      booking_vehicles {
        guide {
          full_name
        }
      }
      created_at
      product {
        id
        name
        slug
        type
        pickupBounds: pickup_bounds
        duration
        pickupRequired: pickup_required
        cancelCutOff: cancel_cutoff
        city: cities_products {
          city {
            coordinates
          }
        }
        product_prices {
          currency
          prices
        }
      }
      transactions(order_by: { created_at: asc }) {
        stripeId: stripe_id
        date
        type
        value
        card_type
        currency
        cardValue: card_value
        items
      }
      passengers: booking_units {
        quantity
        unit {
          id
          label
        }
        price
      }
      REZDY: rezdy {
        reseller
        id
      }
    }
  }
`;
const FIND_BOOKING = gql`
  query FIND_BOOKING($id: String!) {
    boatnew_booking(where: { id: { _eq: $id } }) {
      id
    }
  }
`;
interface FIND_BOOKING_INTERFACE {
  boatnew_booking: [
    {
      id: string;
    }
  ];
}
interface MY_TOURS_PAGE_INTERFACE {
  booking: [
    {
      id: string;
      confirmed: string;
      status: string;
      source: string;
      pickupLocation: string;
      pickupTime: string;
      tourDate: string;
      tourTime: string;
      notes: string;
      pickup_coordinates: {
        lat: number;
        lng: number;
      };
      customer: {
        id: string;
        name: string;
        email: string;
        secondaryEmail: string;
        phone: string;
        secondaryPhone: string;
      };
      booking_vehicles: {
        guide: {
          full_name: string;
        };
      };
      created_at: string;
      product: {
        id: string;
        slug: string;
        name: string;
        type: string;
        pickupBounds: [
          {
            lat: number;
            lng: number;
          }
        ];
        duration: number;
        pickupRequired: boolean;
        cancelCutOff: string;
        city: [
          {
            city: {
              coordinates: {
                lat: number;
                lng: number;
              };
            };
          }
        ];
        product_prices: [
          {
            currency: string;
            prices: {
              adult: string;
              child: string;
              infant: string;
            };
          }
        ];
      };
      transactions: [
        {
          stripeId: string;
          date: string;
          type: string;
          value: string;
          card_type: string;
          cardValue: string;
        }
      ];
      passengers: [
        {
          quantity: number;
          unit: {
            id: string;
            label: string;
          };
          price: number;
        }
      ];
      REZDY: [
        {
          id: string;
          reseller: string;
        }
      ];
    }
  ];
  productDetails: [
    {
      card_media: [
        {
          url: string;
        }
      ];
    }
  ];
}
interface BOOKING_INTERFACE {
  id: string;
  confirmed: string;
  status: string;
  source: string;
  pickupLocation: string;
  pickupTime: string;
  tourDate: string;
  tourTime: string;
  notes: string;
  customer_notes: any[];
  promo_code_id: string;
  total_price: number;
  customer: {
    id: string;
    name: string;
    email: string;
    secondaryEmail: string;
    phone: string;
    secondaryPhone: string;
  };
  booking_vehicles: {
    guide: {
      full_name: string;
    };
  };
  product: {
    id: string;
    name: string;
    type: string;
    slug: string;
    pickupBounds: [{ lat: number; lng: number }];
    duration: number;
    pickupRequired: boolean;
    cancelCutOff: string;
    city: [{ city: { coordinates: { lat: number; lng: number } } }];
    product_prices?: {
      currency: string;
      prices: Record<string, number>;
    }[];
  };
  transactions: [
    {
      stripeId: string;
      date: string;
      type: string;
      value: string;
      card_type: string;
      currency: string;
      cardValue: string;
    }
  ];
  passengers: [
    {
      quantity: number;
      unit: {
        id: string;
        label: string;
      };
      price: number;
    }
  ];
  REZDY: [
    {
      id: string;
    }
  ];
  notFound: boolean;
  productDetails: [
    {
      card_media: [
        {
          url: string;
        }
      ];
    }
  ];
}
export { FIND_BOOKING, BOOKING_SEARCH };
export type {
  MY_TOURS_PAGE_INTERFACE,
  BOOKING_INTERFACE,
  FIND_BOOKING_INTERFACE
};
